import {ObjectFactory} from '@/config/objectFactory';
import {Invoice} from '@/types/entity';
import {ApiRequest, QueryRecordsRequest} from '@/types/request';
import {ApiResponse} from '@/types/response';
import {CommonUtils} from '@/util/commonUtils';
import {MedTransGoConstants} from '@/util/constants';
import {DateUtils} from '@/util/dateUtils';
import {IInvoiceService} from '../iInvoiceService';

export class InvoiceService implements IInvoiceService {

    public async getInvoiceList(baseURL: string, getInvoiceRequest: QueryRecordsRequest, type: any):
        Promise<ApiResponse<Invoice[]>> {
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            conditions: getInvoiceRequest.conditions ? getInvoiceRequest.conditions : [],
            order: {
                createdOn: -1,
            },
            start: getInvoiceRequest.start,
            limit: getInvoiceRequest.limit,
        };
        if (status && queryRecordsRequest.conditions) {
            queryRecordsRequest.conditions.push({
                op: 'eq',
                fieldName: 'status',
                value: status,
            });
        }
        if (getInvoiceRequest.advanceFilterRequest && queryRecordsRequest.conditions) {
            const advancedSearchRequest = getInvoiceRequest.advanceFilterRequest;
            if (advancedSearchRequest.appointmentDate) {
                const startDate = DateUtils.convertToUTCInMillis(advancedSearchRequest.appointmentDate.startDate);
                const endDate = DateUtils.convertToUTCInMillis(advancedSearchRequest.appointmentDate.endDate);
                queryRecordsRequest.conditions.push({
                    fieldName: 'createdOn',
                    op: 'between',
                    value: [startDate, endDate],
                });
                if (advancedSearchRequest.searchString) {
                    queryRecordsRequest.conditions.push({
                        fieldName: 'customerName',
                        op: 'eq',
                        value: advancedSearchRequest.searchString,
                    });
                }
            }
        }
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/list`,
            data: queryRecordsRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<Invoice[]>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async getPendingInvoice(baseURL: string): Promise<ApiResponse<any[]>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/pendingList`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any[]>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async payInvoice(baseURL: string): Promise<ApiResponse<any[]>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/pay`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any[]>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async getInvoiceReceipt(baseURL: string, id: string): Promise<ApiResponse<any>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/${id}`,
            timeout: 50000,
            loaderEvent: {
                show: true,
            },
            responseType: 'arraybuffer',
            headers: {
                accept: 'application/pdf',
            },
        };
        const response = await iHttpService.get<any>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async getResource(baseUrl: string, resourceId: string): Promise<ApiResponse<string>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: baseUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/${resourceId}`,
        };
        const response = await iHttpService.get<any>(apiRequest);
        return response.data;
    }
}
